export const TRIGGER_FORM_VALIDATION = Symbol('TRIGGER_FORM_VALIDATION');
